import React, { useEffect} from 'react';
import { connect } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { getProductByName } from '../../redux/actions/Product/ProductActions';
const GetProductByName = ({products, getProductByName}) => {
    const params=useParams();
    useEffect(()=> {
        getProductByName(params.name);
        console.log(products);
    },
    [] );
    const handleGoBack = () =>{
        //history.push('/product/all');
        window.location = '/product/all';
    };
    return(
        <div className="container-fluid product-details-page">
            <h4 className="text-center py-2 product-header">Product Details</h4>
            <div className="row">
                <div className="col-md-6 p-5 mx-auto shadow product-details">
                    <h5><span className='detail'>Product ID:</span> {products.productId}</h5>
                    <h5><span className='detail'>Product Name:</span> {products.productName}</h5>
                    <h5><span className='detail'>Product Description:</span> {products.productDescription}</h5>
                    <h5><span className='detail'>Quantity:</span> {products.productQuantity}</h5>
                    <h5><span className='detail'>Type:</span> {products.productType}</h5>
                    <h5><span className='detail'>Date:</span> {products.date}</h5>
                    <button type="button" className="btn btn-primary"  onClick={handleGoBack}>Go Back</button>
                    <div className="form-group my-3 ">
                        <Link className="btn btn-primary" to={'/product/all'}>
                        Go Back
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    console.log(state);
    return {
        products: state.products
    };
};

const mapDispatchToProps = {
    getProductByName
};


export default connect(mapStateToProps, mapDispatchToProps)(GetProductByName);